module.exports = __webpack_public_path__ + "static/media/grid.c1c82dc9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/d3Components/customBarchartWithCircle/grid.jpeg
// module id = 1465
// module chunks = 0